import { Box, useTheme, Typography } from "@mui/material";
import { Helmet } from "react-helmet";
import React, { useState } from "react";
import GridContainer from "../../components/grid/GridContainer.jsx";
import GridItem from "../../components/grid/GridItem.jsx";
import { getLeranMoreStyle } from "../../components/customstyles/LearnMoreStyle.jsx";
import GlobalGudgmentOne from "../../assets/images/LearnMore/GlobalGudgmentOne.png";
import GlobalGudgmentTwo from "../../assets/images/LearnMore/GlobalGudgmentTwo.png";
import BodyAreaThree from "../../assets/images/LearnMore/BodyAreaThree.png";
import Breadcrumbs from "./Breadcrumbs.jsx";

const useStyles = () => {
  let theme = useTheme();
  return getLeranMoreStyle(theme);
};

function GlobalJudgments() {
  const styles = useStyles();
  const [isLoadingCompleted, setLoading] = useState(true);

  const handleGlobalLoading = () => {
    setLoading(false);
  };
  return (
    <Box sx={styles.learnMorePageStyle}>
      <Helmet>
        <title>Patients</title>
      </Helmet>
      <Breadcrumbs
        handleLoading={handleGlobalLoading}
        name={"Global Judgments"}
      />
      {!isLoadingCompleted && (
        <div className="FSUnmask">
          <GridContainer>
            <GridItem
              lg={12}
              sm={12}
              md={12}
              xs={12}
              sx={{ marginTop: "30px" }}
            >
              <Box>
                <Typography sx={styles.learnMoreHeading}>
                  Global Judgments
                </Typography>
              </Box>

              <Box sx={{ marginTop: "30px" }}>
                <Typography sx={styles.bodyAreasText}>
                  Global Judgments ratings are not factored into the overall
                  AIMS score but they are important factors to consider because
                  even very subtle movements, that go unnoticed, can have a
                  significant impact on patients.
                </Typography>
              </Box>
              <Box sx={{ marginTop: "20px" }}>
                <img
                  src={GlobalGudgmentOne}
                  alt="GlobalGudgmentOne"
                  width="100%"
                  height="567px"
                />
              </Box>
              <Box sx={{ marginTop: "15px" }}>
                <Typography sx={styles.globalJudgmentsText}>
                  Item 8 assesses the overall severity of movements. This score
                  is based on the{" "}
                  <b>
                    highest single score in items 1 to 7 from the Body Areas
                    section.
                  </b>
                </Typography>
              </Box>
              <Box sx={{ marginTop: "20px" }}>
                <img
                  src={GlobalGudgmentTwo}
                  alt="GlobalGudgmentTwo"
                  width="100%"
                  height="606px"
                />
              </Box>
              <Box sx={{ marginTop: "10px" }}>
                <Typography sx={styles.globalJudgmentsText}>
                  Items 9 and 10 assess the impact of TD on the patient’s life
                  and may be useful in clinical decision-making. Ask the patient
                  whether any movements in their mouth, face, hands, or feet
                  interfere with their regular activities and the extent to
                  which their movements are bothersome:
                </Typography>
              </Box>
              <Box sx={{ marginTop: "15px" }}>
                <img
                  src={BodyAreaThree}
                  alt="BodyAreaThree"
                  width="100%"
                  height="72px"
                />
              </Box>
            </GridItem>
          </GridContainer>
        </div>
      )}
    </Box>
  );
}

export default GlobalJudgments;
